module.exports = __webpack_public_path__ + "img/mobile-4.e4688258.jpg";